module.exports = __webpack_public_path__ + "static/media/settings.8a325356.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/event-toolbar/settings.svg
// module id = 775
// module chunks = 0